import { Link } from "react-router-dom";
import { Clock, ArrowUpRight } from "lucide-react";
import { FASHION_HERO_IMAGE, FASHION_HERO_IMAGE_MOBILE } from "../data/site";

export default function DressesTeaser() {
  return (
    <section
      id="fashion-soon"
      data-testid="dresses-teaser-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#0B0B0B] border-t border-[#1a1a1a]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        {/* Image */}
        <div className="lg:col-span-6 relative reveal">
          <div className="relative overflow-hidden aspect-[4/5] md:aspect-[5/4] card-sheen">
            <picture>
              <source media="(max-width: 768px)" srcSet={FASHION_HERO_IMAGE_MOBILE} />
              <img
                src={FASHION_HERO_IMAGE}
                alt="Kendi Collections fashion coming soon"
                className="w-full h-full object-cover"
                style={{ filter: "brightness(0.78)" }}
                loading="lazy"
              />
            </picture>
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/60 via-transparent to-transparent" />
            <div className="absolute top-5 left-5 z-10 inline-flex items-center gap-2 border border-[#D4AF37]/50 backdrop-blur-md bg-[#0B0B0B]/50 px-3 py-1.5">
              <Clock className="w-3 h-3 text-[#D4AF37]" />
              <span className="text-[9px] tracking-[0.42em] uppercase text-[#D4AF37]">
                Coming Soon
              </span>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-6 reveal">
          <span className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]">
            On the Horizon
          </span>
          <h2 className="mt-5 font-serif-display text-[32px] sm:text-4xl md:text-5xl leading-[1.08] tracking-tight text-white">
            A fashion line is <br />
            <span className="italic text-gold-shimmer">coming quietly.</span>
          </h2>
          <p className="mt-6 text-[15px] leading-[1.9] text-white/65 font-light max-w-lg">
            Alongside our heritage pieces, we&apos;re quietly developing a
            capsule of vintage-inspired dresses. No pre-orders yet — just a
            promise that craft will come first.
          </p>

          <Link
            to="/dresses"
            data-testid="dresses-teaser-preview-link"
            className="mt-8 inline-flex items-center gap-2 btn-outline-gold"
          >
            <span>Preview the Line</span>
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
